import { Search } from 'lucide-react'
import { useCallback, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { searchRepos } from '../api.js'
import EmptyState from '../components/EmptyState.jsx'
import ErrorState from '../components/ErrorState.jsx'
import LoadingState from '../components/LoadingState.jsx'
import RepoCard from '../components/RepoCard.jsx'

function SearchPage() {
  const [searchParams] = useSearchParams()
  const query = searchParams.get('q')?.trim() || ''
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(Boolean(query))
  const [error, setError] = useState('')

  const load = useCallback((signal) => {
    if (!query) return
    setLoading(true)
    setError('')
    searchRepos(query, signal)
      .then((data) => setItems(data.items))
      .catch((requestError) => {
        if (requestError.name !== 'AbortError') setError(requestError.message)
      })
      .finally(() => setLoading(false))
  }, [query])

  useEffect(() => {
    const controller = new AbortController()
    load(controller.signal)
    return () => controller.abort()
  }, [load])

  return (
    <div className="page-container">
      <section className="page-heading compact-heading">
        <div>
          <span className="eyebrow">SEARCH ARCHIVE</span>
          <h1>搜索结果</h1>
          <p>{query ? `“${query}” 找到 ${items.length} 个已收录项目。` : '输入关键词搜索已收录项目。'}</p>
        </div>
      </section>

      {loading && <LoadingState label="正在搜索项目" />}
      {!loading && error && <ErrorState message={error} onRetry={() => load()} />}
      {!loading && !error && items.length === 0 && (
        <EmptyState
          icon={<Search size={28} />}
          title={query ? '没有匹配的项目' : '等待搜索'}
          message={query ? '换一个项目名、语言或技术关键词试试。' : '使用顶部搜索框开始查找。'}
        />
      )}
      {!loading && !error && items.length > 0 && (
        <div className="repo-list">
          {items.map((repo) => (
            <RepoCard
              key={repo.id}
              repo={repo}
              onFavoriteChange={(repoId, isFavorited) => {
                setItems((current) => current.map((item) => (
                  item.id === repoId ? { ...item, isFavorited } : item
                )))
              }}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default SearchPage
